import { Injectable } from '@angular/core';
import { FieldType, Formatters } from 'angular-slickgrid';
import { masterGridConfig } from '../../../app-enum.enum';
@Injectable()
export class RouteListService {

  constructor() { }

  routeFilterConfig = {
    'showSideBar': false,
    'showReset': true
  };
  isFromTransaction = false;

  //grid
  getRouteTableColumnConfigs() {
    return [{
      id: 'id',
      name: 'Seq No',
      field: 'id',
      sortable: true,
      columnGroup: 'Route Details',
      formatter: function (row) { return (row + 1); },
      minWidth: 40
    },
    {
      id: 'ROUTE_CODE',
      name: 'Route Code',
      field: 'ROUTE_CODE',
      sortable: true,
      type: FieldType.string,
      formatter: (row, cell, value, columnDef, dataContext) => {
        return '<a class="cursor-pointer">' + value + '</a>';
      },
      columnGroup: 'Route Details',
      minWidth: 120
    },
    {
      id: 'ROUTE_DESC',
      name: 'Route Description',
      field: 'ROUTE_DESC',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Route Details',
      minWidth: 150
    },
    {
      id: 'INTRANSIT_ORIGIN',
      name: 'Origin',
      field: 'INTRANSIT_ORIGIN',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Route Details',
      minWidth: 200
    },
    {
      id: 'VIA',
      name: 'Via',
      field: 'VIA',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Route Details',
      minWidth: 200
    },
    {
      id: 'INTRANSIT_DEST',
      name: 'Destination',
      field: 'INTRANSIT_DEST',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Route Details',
      minWidth: 200
    },
    {
      id: 'JOURNEYLEGS',
      name: 'Journey Legs',
      field: 'JOURNEYLEGS',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Route Details',
      minWidth: 430
    },
    {
      id: 'DISTANCE',
      name: 'Total Distance (kms)',
      field: 'DISTANCE',
      sortable: true,
      type: FieldType.float,
      formatter: Formatters.decimal,
      columnGroup: 'Route Details',
      minWidth: 100
    },
    {
      id: 'HOURS',
      name: 'Time Taken (hh:mm)',
      field: 'HOURS',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Route Details',
      minWidth: 90
    },
    {
      id: 'STATUS',
      name: 'Status',
      field: 'STATUS',
      sortable: true,
      type: FieldType.string,
      columnGroup: 'Route Details',
      minWidth: 60
    }];
  }

  //configuration
  getRouteTableConfigs(scope) {
    return {
      gridId: 'routeListTable',
      idField: 'id',
      containerHeight: '98vh',
      canExportAsExcel: true, // TODO: Need to Configure
      selectionMode: 'multiple', // TODO: Need to configure
      exportFileName: 'Route List',
      dateFormat: 'DD/MM/YYYY',
      canAddRowManually: false,
      canDeleteRowManually: false,
      canCopyRows: false,
      showColumnFilter: false,
      showFilter: true,
      showAdvanceFilter: true,
      emptyObject: {},
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableCheckboxSelector: false,
      enableRowSelection: true,
      editable: true,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: false
      },
      autoResize: {
        maxHeight: masterGridConfig.gridHeightForMasterList,
      },
      createPreHeaderPanel: true,
      showPreHeaderPanel: true,
      enablePagination: false,
      enableGrouping: false,
      autoEdit: true,
      alwaysShowVerticalScroll: false,
      forceFitColumns: false
    };
  }

  //search
  getRouteFilterTemplate() {
    return [{
      'id': 'strRouteIdFrom',
      'labelName': 'Route Code',
      'type': 'input',
      'inputType': 'text',
      'patchValue': '',
      'validations': [],
      'isReadOnly': false,
      'isVisible': true,
      'position': 1,
      'class': 'col-md-12'
    }, {
      'id': 'strRouteDesc',
      'labelName': 'Route Description',
      'type': 'input',
      'inputType': 'text',
      'isReadOnly': false,
      'isVisible': true,
      'validations': [],
      'position': 2,
      'class': 'col-md-12'
    }, {
      'id': 'strOrigin',
      'labelName': 'Origin',
      'type': 'search',
      'placeholder': 'Select Origin',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': '',
      'defaultValue': {
        'value': 'ALL',
        'id': 'ALL'
      },
      'datasource': [],
      'validations': [],
      'position': 3,
      'class': 'col-md-12'
    }, {
      'id': 'strStatus',
      'labelName': 'Status',
      'type': 'search',
      'placeholder': 'Select Status',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': '',
      'defaultValue': {
        'value': 'ALL',
        'id': 'ALL'
      },
      'datasource': [],
      'validations': [],
      'position': 4,
      'class': 'col-md-12'
    }, {
      'id': 'strVia',
      'labelName': 'Via',
      'type': 'search',
      'placeholder': 'Select Via',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': '',
      'defaultValue': {
        'value': 'ALL',
        'id': 'ALL'
      },
      'datasource': [],
      'validations': [],
      'position': 5,
      'class': 'col-md-12'
    }, {
      'id': 'strDestination',
      'labelName': 'Destination',
      'type': 'search',
      'placeholder': 'Select Destination',
      'minlength': 1,
      'isVisible': true,
      'model': '',
      'changeApi': '',
      'displayField': 'value',
      'valueField': 'id',
      'defaultValue': {
        'value': 'ALL',
        'id': 'ALL'
      },
      'datasource': [],
      'validations': [],
      'position': 6,
      'class': 'col-md-12'
    }, {
      'id': 'searchButton',
      'buttonName': 'Search',
      'onClickEvent': '',
      'onChangeEvent': '',
      'isVisible': true,
      'type': 'button',
      'isSearchBtn': true
    }];
  }
}
